import { Button, Form, Input } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

const { Item } = Form;

export const ButtonConfirm = styled(Button)`
  height: ${(props) => props.theme["@height-button-lg"]};
  width: auto;
  color: ${(props) => props.theme["@default-color"]};
  font-size: ${(props) => props.theme["@large-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  border: none;
  :hover,
  :focus {
    color: ${(props) => props.theme["@default-color"]};
    background-color: ${(props) => props.theme["@hover-input-background-color"]};
    border: none;
  }
`;

export const AlignItemSubmit: React.CSSProperties = { textAlign: "right" };

export const SSOContainerUnregister = styled.div`
  border-top: 1px solid #d9d9d9;
  text-align: center;
  padding-top: 16px;

  > span {
    color: var(--color-neutral-600);
    border-bottom: 2px solid var(--color-neutral-600);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    cursor: pointer;
  }
`;

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 4px;

  > span {
    color: var(--color-neutral-600);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-regular);
    line-height: 26px;

    > a {
      font-weight: var(--font-weight-semibold);
      color: #0000e4;
    }
  }
`;

export const SSOContainerButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  .primaryButton {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 100%;
    margin-top: 7px;
    box-shadow: none;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px ${(props) => props.theme["@hover-input-background-color"]} !important;
    background-color: ${(props) => props.theme["@primary-color-brand"]};
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    outline: none !important;
    -webkit-animation: none !important;
    animation: none !important;
    :hover {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
    :focus {
      border: 1.6px ${(props) => props.theme["@hover-input-background-color"]} !important;
    }
  }
  .primaryButton[disabled] {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }

  .secondaryButton[disabled] {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
    :hover {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@muted-background"]};
      color: ${(props) => props.theme["@disabled-button"]};
    }
  }

  .secondaryButton {
    height: ${(props) => props.theme["@height-button-lg"]};
    color: ${(props) => props.theme.colors.text};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px solid ${(props) => props.theme.colors.text} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    height: ${(props) => props.theme["@height-button-lg"]};
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]};
      color: ${(props) => props.theme.colors.text};
    }
  }
`;

export const SSOContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--color-neutral-600);

  > div {
    display: flex;
    align-items: center;
    gap: 19px;
  }

  .login-title {
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-semibold);
    line-height: 36px;
  }

  .login-subtitle {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-regular);
    line-height: 26px;
  }
`;

export const SSOContainer = styled.div`
  display: flex;
  width: 380px;
  flex-direction: column;
  box-shadow: var(--shadow-level-2) rgba(0, 0, 0, 0.16);
  background-color: var(--color-contrast-white);
  padding: 24px;
  height: fit-content;
  border-radius: 10px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  gap: 15px;
`;

export const Greetings = styled.span`
  gap: 4px;
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  font-size: ${(props) => props.theme["@xl-font-size"]};
  font-family: ${(props) => props.theme["@font-family"]};
`;

export const TitleDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  gap: 20px;
`;

export const FormContainer = styled.div`
  margin: 24px 0;

  .ant-form-item {
    margin-bottom: 2px !important;
  }
`;

export const FormItem = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    box-shadow: none;
    &:hover {
      border-color: ${(props) => props.theme["@secondary-color"]};
    }
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 300;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
    > span {
      pointer-events: auto;
    }
  }

  .ant-select-arrow {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }

  .ant-btn-primary {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 140px;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
  }

  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector,
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text};
    outline-offset: 1.6px;
    align-items: center;
  }
`;

export const InputRole = styled(Input)`
  border: 1px solid ${(props) => props.theme.colors.manatee};
  height: ${(props) => props.theme["@height-input-lg"]};
`;

export const LocationIcon: React.CSSProperties = {
  marginRight: "8px",
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  fontSize: theme["@medium-font-size"],
  fontWeight: theme["@normal-font-weight"],
};

export const LoginWrapper = styled.section`
  width: 100%;
  min-height: 100%;
  max-height: 100vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  background-color: ${(props) => props.theme["@default-background"]};
  position: relative;

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }
`;

export const LoginBg = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url(${(props) => props.background});
  background-position: left center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  opacity: 1;
`;
export const Login = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: 85% 15%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  height: auto;
  text-align: left;
  height: 100vh;
  form {
    margin-top: 15px;
    @media only screen and (min-width: 1281px) {
      width: 30vw;
    }
  }
`;

export const ImagesWrapper = styled.div`
  width: 300px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  align-content: center;
`;

export const Container = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-neutral-100);
  justify-content: end;

  * {
    font-family: var(--font-family-base);
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin: 0 10%;
  align-items: center;

  @media (max-width: 900px) {
    flex-direction: column;
    margin: 0;
    justify-content: space-around;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  width: 385.5px;
  height: 117.75px;
`;

export const FooterBar = styled.div`
  width: 100%;
  height: 56px;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme["@primary-color-brand"]};
`;

export const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  margin: 0 10px;
  color: ${(props) => props.theme.text};
`;

export const BtnSubmit: React.CSSProperties = { width: 125 };
